import { useQuery } from '@tanstack/react-query';
import { getMyReturns } from '../../api/apiReturns';
import { useAuthContext } from '../../auth/useAuthContext';

export const useGetMyReturns = (params = {}) => {
    const { isAuthenticated } = useAuthContext();
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ['my-returns', params],
        queryFn: () => getMyReturns(params),
        enabled: isAuthenticated,
        keepPreviousData: true,
    });

    const returns = data?.data?.data || [];
    const meta = data?.data?.meta || { current_page: 1, per_page: params?.per_page || 15, total: returns.length };
    return { returns, meta, isLoading, error, refetch };
};

export default useGetMyReturns;
